export default __webpack_public_path__ + "static/media/Comercial Martins.80cb12d0.png";